module.exports = __webpack_public_path__ + "img/water_level_error.7788d12c.svg";